<script lang="ts">
  import { PUBLIC_APP_URL } from '$env/static/public';

  export let darkMode = false;
</script>

<a href={PUBLIC_APP_URL}>
  <svg viewBox="0 0 37 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.1656 22.6948C32.2095 21.5876 35.467 19.3079 35.467 12.925C35.467 10.8245 34.7485 0.354492 20.7284 0.354492H9.94982C-0.365653 0.354492 0.00162297 10.3197 0.00162297 10.3197V48.4057C0.00162297 48.4964 0.0369535 48.5834 0.0998406 48.6475C0.162728 48.7116 0.248006 48.7477 0.336942 48.7477H17.8381C27.6905 48.7477 30.1816 47.0054 32.8642 44.3349C34.175 43.0188 35.2158 41.4498 35.9259 39.7194C36.6359 37.9889 37.0011 36.1316 37 34.2558C37 28.4753 34.7165 24.7302 30.1656 22.6948ZM25.3751 14.0811C25.3751 18.3961 21.2553 18.966 18.7962 18.966H10.0297V10.5314C10.0296 10.1915 10.1598 9.86498 10.3925 9.6216C10.6252 9.37822 10.9419 9.23724 11.2752 9.22874H18.5407C23.3631 9.31015 25.4071 10.7268 25.4071 14.0811H25.3751ZM19.4349 39.8408H10.1414V27.7751H19.898C23.0917 27.7751 26.5887 29.208 26.5887 33.2137C26.5089 37.7566 24.2254 39.8408 19.4349 39.8408Z"
      fill={darkMode ? '#fff' : '#1D1D1B'}
    />
  </svg>
</a>

<style lang="scss">
  svg {
    width: 37px;
    height: 48.39px;
    path {
      transition: 0.3s ease all;
    }
  }

  @include mobile {
    svg {
      width: 27px;
      height: 34px;
    }
  }
</style>
